import axios from 'axios';

const AUTH_TOKEN = process.env.REACT_APP_API_AUTH_TOKEN;

const gusApi = axios.create({
    baseURL: `/api`,
    headers: {
        'Accept': '*/*',
        'Authorization': `Basic ${AUTH_TOKEN}`
    }
});

export const fetchFirmaByNip = async (nip) => {
    try {
        const response = await gusApi.get(`/gus/firma/nip/${nip}`);
        return response.data;
    } catch (error) {
        console.error('Błąd podczas pobierania danych z GUS:', error);
        throw error;
    }
};

export default {
  fetchFirmaByNip
};